/**
 * System Status Button Component
 *
 * Displays system status (e.g., "BETA") as a pill-shaped badge.
 * Styles from Figma design system using design tokens.
 *
 * Figma specs:
 * - Dimensions: 40.912px × 20.974px
 * - Background: #F3F4F6 (Lightest Gray)
 * - Text: #4A5565 (Accent Md Gray)
 * - Typography: Inter Regular, 9.5px, line-height 14px
 */
"use client";

import { colors } from "@/styles/design-tokens";

interface SystemStatusButtonProps {
  status?: string;
  className?: string;
}

export function SystemStatusButton({ status = "BETA", className = "" }: SystemStatusButtonProps) {
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full px-[7px] py-[3.31px] ${className}`}
      style={{
        backgroundColor: colors.accent.lightestGray,
        minWidth: "40.912px",
        height: "20.974px",
      }}
    >
      <span className="text-caption-sm text-ink-secondary">{status}</span>
    </div>
  );
}
